// @core/api/endpoints/project/delete_sprint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/project';

/**
 * Delete sprint
 * Deletes a sprint that is in planning state. Active or completed sprints cannot be deleted. Items assigned to the sprint are unassigned.
 */
export async function DeleteSprint(
  project_id: string,
  sprint_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/sprints/:sprint_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':sprint_id', encodeURIComponent(sprint_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
